<mat-form-field
    [ngClass]="isGlobalSelector ? 'selector-dropdown-button' : 'form-selector-dropdown-button'"
    appearance="outline"
>
    <mat-select
        #timeframeSelector
        (keydown)="onKeyDown($event)"
        (openedChange)="onSelectorOpenedChange($event)"
        [(ngModel)]="SelectedTimeframe"
        [compareWith]="compareObjects"
        [panelClass]="isGlobalSelector ? 'selector-dropdown-wrap' : 'form-selector-dropdown-wrap'"
        id="timeframeSelector"
        tabindex="8"
    >
        <mat-select-trigger class="fs-14 letter-spacing-0"><span i18n>Date</span>: {{ SelectedTimeframe?.label }}</mat-select-trigger>

        <!-- Timeframe list -->
        @if (timeframesDataSource && timeframesDataSource.length > 0) {
        <!--            <section class='selector-list-wrap m-t-0'>-->
        @for (option of timeframesDataSource; track option) {
        <mat-option
            class="fs-14"
            [value]="option"
        >
            {{ option?.label }}
        </mat-option>
        }
        <!--            </section>-->
        }
    </mat-select>
</mat-form-field>
